/* ============================================================
   CUTE CALCULUS — THE CATALOG
   ------------------------------------------------------------
   This ONE file is the whole site's brain.

   Every time you make something new, add ONE entry here and it
   shows up automatically in three places:
       - the "Just added" panel on the home page
       - the Free Library page   (if kind is "free" or "tool")
       - the Print Books page    (if kind is "book")
   and inside the course finder on the home page.

   Changing kind from "free" to "shop" is how you put a price on
   something. It leaves the Free Library on its own and starts
   showing under the Digital filter instead. Nothing else to do.

   TO ADD SOMETHING NEW: copy the block marked COPY ME at the
   bottom, paste it at the TOP of the items list, fill it in,
   save. That is the whole job. Newest goes on top by habit,
   but the site sorts by the "added" date anyway.

   FIELDS
     id     a short unique nickname, no spaces
     title  what it is called
     blurb  one short line. Keep it short.
     kind   "free"  a file anyone can download, no email asked
            "tool"  something interactive on the site
            "book"  a printed book on Amazon
            "shop"  a paid digital product (Etsy or your store)
     course one or more of: elementary, prealgebra, algebra1,
            geometry, algebra2, precalc, calculus, sat, tsi,
            chemistry
     grade  a plain label like "6th to 8th" or "9th to 12th"
     sym    the little symbol on its tile. One or two characters.
     color  blush peach butter mint seafoam sky peri lilac gum
     url    the link. LEAVE IT AS "" AND IT SHOWS AS COMING SOON,
            which is safe, so an unfinished thing never 404s.
     cta    the button words. Leave it out for a sensible default.
     added  the date you added it, as "2026-09-10"
     pages  optional, books only
     price  optional. Shows as a small chip on the card, wherever that
            card appears. Leave it as '' and no chip shows, which is
            safe. Write it the way you want it read, like '$6'.
     group  optional. Things that belong to one growing set, like
            "review" for the term review packets. The Review Packets
            page builds its grid from this.
     term   optional, and only with group. Which term it covers, like
            "1st six weeks". Add the next term's files with the same
            group and a new term and a new column appears by itself.
     sheet  optional. The id of a related item, shown as a second,
            quieter button on the same card. Used to hang each course's
            cheat sheet off its free packet. If that item has no link
            yet the second button simply does not appear.

   BOOKS ONLY, extra fields used on the Print Books page
     img    the cover picture. Upload it in Shopify under
            Content > Files, copy the link, paste it here.
     long   a longer description, two or three lines
     series books in the same series sit together. Use the same
            words for each one, like "Fact Family Friends"
     part   "Book One", "Book Two", shown as a little tag
   ============================================================ */

window.CC_CATALOG = {

  /* the courses down the left of the home page finder */
  courses: [
    { key:'elementary', name:'Elementary math', sym:'+',  color:'mint',    note:'facts, times tables, fractions' },
    { key:'prealgebra', name:'Pre-Algebra',     sym:'%',  color:'butter',  note:'ratios, integers, first equations' },
    { key:'algebra1',   name:'Algebra 1',       sym:'x',  color:'blush',   note:'solving, graphing, factoring' },
    { key:'geometry',   name:'Geometry',        sym:'△',  color:'peach',   note:'proofs, angles, area' },
    { key:'algebra2',   name:'Algebra 2',       sym:'x²', color:'sky',     note:'functions, logs, quadratics' },
    { key:'precalc',    name:'Precalculus',     sym:'π',  color:'peri',    note:'trig, parent functions, limits' },
    { key:'calculus',   name:'Calculus',        sym:'∫',  color:'lilac',   note:'derivatives, integrals, AP' },
    { key:'sat',        name:'SAT & test prep', sym:'★',  color:'gum',     note:'reading, writing, vocabulary, Desmos, math' },
    /* NEW. The TSIA2 files were already tagged course:['tsi'] but there was
       no tsi course here, so they never showed up in the finder. */
    { key:'tsi',        name:'TSIA2 & placement', sym:'✓', color:'seafoam', note:'Texas placement test, adult retakers' },
    /* NEW. Chemistry is a real line now, three titles and counting. */
    { key:'chemistry',  name:'Chemistry',       sym:'Ch', color:'mint',    note:'AP Chem and first year chemistry' }
  ],

  items: [

    /* ---------- newest, September 15 to 20 ---------- */

    {
      id:'sat-reading-lab',
      title:'SAT Reading Lab',
      blurb:'The whole Reading and Writing section. 238 questions, 100 vocab words, and a method page before every skill.',
      kind:'tool', course:['sat'], grade:'9th to 12th',
      sym:'★', color:'gum',
      url:'/pages/sat-reading-lab',
      cta:'Start practicing',
      long:'Thirty blocks that alternate heavy and light. Words in context, central ideas, purpose, evidence, data, inferences and cross text, then punctuation, grammar, transitions and notes questions, each with a short method page first. Every answer is checked the moment you pick it, anything you miss lands in a miss log, and it remembers where you were.',
      added:'2026-09-20'
    },

    {
      id:'final-precalc',
      title:'AP Precalculus Final Exam Prep',
      blurb:'The whole year in one packet, built for the final.',
      kind:'shop', course:['precalc'], grade:'10th to 12th',
      sym:'π', color:'peri',
      url:'',                       /* <- paste the listing link in cc-links.js */
      cta:'Buy the packet',
      price:'',                     /* <- your price */
      pages:41,
      long:'A full year sweep aimed at the final exam. Every unit, worked examples, practice, and a full length practice final with a worked key. Print at home on letter paper.',
      added:'2026-09-20'
    },

    {
      id:'before-ap-chem',
      title:'Before AP Chem',
      blurb:'81 pages, 65 short lessons, 337 problems. A whole first year of chemistry before you walk into AP.',
      kind:'shop', course:['chemistry'], grade:'9th to 12th',
      sym:'Ch', color:'sky',
      url:'',                       /* <- paste the listing link in cc-links.js */
      cta:'Buy the workbook',
      price:'',                     /* <- your price */
      pages:81,
      long:'For a student joining AP Chemistry with no chemistry behind them. Sixty five short lessons across the whole first year course, each with its own practice, and 337 problems in all with worked answers.',
      added:'2026-09-18'
    },

    {
      id:'apchem-sigfigs',
      title:'AP Chemistry Significant Figures',
      blurb:'41 pages. Every sig fig rule, shown on real AP problems, with no arithmetic in the way.',
      kind:'free', course:['chemistry'], grade:'10th to 12th',
      sym:'sf', color:'butter',
      url:'',                       /* <- paste the PDF file link */
      cta:'Download free',
      pages:41,
      long:'Counting, rounding, multiply and divide, add and subtract, multi step, logs and pH, then the real AP problems: density, dilution, heat, titration, gas laws, molar mass and a stoichiometry chain. Every example names the sig figs in each number and points at the one that limits the answer. Six practice sets, a 50 question test, and a key with a reason on every line.',
      added:'2026-09-18'
    },

    {
      id:'precalc-placement',
      title:'Ready for AP Precalculus',
      blurb:'Algebra 2 review plus a Precalculus introduction, built for a placement test.',
      kind:'free', course:['precalc','algebra2'], grade:'9th to 12th',
      sym:'π', color:'peach',
      url:'',                       /* <- paste the PDF file link */
      cta:'Download free',
      added:'2026-09-19'
    },

    {
      id:'homeschool-k',
      title:'Homeschool Math, Kindergarten',
      blurb:'A full year in one book. 36 weekly worksheets in 9 units, answer keys, certificate.',
      kind:'shop', course:['elementary'], grade:'Kindergarten',
      sym:'+', color:'blush',
      url:'', cta:'Buy the bundle', price:'', pages:91,
      long:'One book, one year. A year map, 36 weeks at two pages each, a challenge page after every unit, full answer keys and a completion certificate. Comes in the pastel version and a plain black and white version for easy printing.',
      added:'2026-09-17'
    },
    {
      id:'homeschool-1',
      title:'Homeschool Math, Grade 1',
      blurb:'A full year in one book. 36 weekly worksheets in 9 units, answer keys, certificate.',
      kind:'shop', course:['elementary'], grade:'1st grade',
      sym:'+', color:'peach',
      url:'', cta:'Buy the bundle', price:'', pages:91,
      long:'One book, one year. A year map, 36 weeks at two pages each, a challenge page after every unit, full answer keys and a completion certificate. Comes in the pastel version and a plain black and white version for easy printing.',
      added:'2026-09-17'
    },
    {
      id:'homeschool-2',
      title:'Homeschool Math, Grade 2',
      blurb:'A full year in one book. 36 weekly worksheets in 9 units, answer keys, certificate.',
      kind:'shop', course:['elementary'], grade:'2nd grade',
      sym:'+', color:'butter',
      url:'', cta:'Buy the bundle', price:'', pages:91,
      long:'One book, one year. A year map, 36 weeks at two pages each, a challenge page after every unit, full answer keys and a completion certificate. Comes in the pastel version and a plain black and white version for easy printing.',
      added:'2026-09-17'
    },

    {
      id:'apchem-unit1',
      title:'AP Chemistry Unit 1, from zero',
      blurb:'58 pages. Written for someone who has never taken chemistry, with a 50 question test.',
      kind:'free', course:['chemistry'], grade:'10th to 12th',
      sym:'Ch', color:'mint',
      url:'',                       /* <- paste the PDF file link */
      cta:'Download free',
      pages:58,
      long:'Starts before chemistry starts: seven pages of pre-chemistry basics, then Unit 1 in College Board order. Every formula, how to use it and why, 25 rules to know, ten traps, 51 practice problems, and a 50 question 100 point test with a full worked key.',
      added:'2026-09-15'
    },

    {
      id:'precalc-start',
      title:'Precalculus, the first three weeks',
      blurb:'The start of year packet. Everything the first three weeks covers, with a worked key.',
      kind:'free', course:['precalc'], grade:'10th to 12th',
      sym:'π', color:'seafoam',
      url:'',                       /* <- paste the PDF file link */
      cta:'Download free',
      added:'2026-09-11'
    },

    {
      id:'ivt-packet',
      title:'Intermediate Value Theorem packet',
      blurb:'AP Calculus AB. Lesson, three levels of practice, and a 100 point test with a full key.',
      kind:'free', course:['calculus'], grade:'11th to 12th',
      sym:'∫', color:'lilac',
      url:'',                       /* <- paste the PDF file link */
      cta:'Download free',
      added:'2026-09-10'
    },

    /* ---------- the two sided cheat sheets, one per course ----------
       Free, like the packets. Each one is also hung off its matching
       first six weeks packet through the "sheet" field down below, so it
       shows as a second button there as well as in the Free Library. */
    {
      id:'geometry-sheet',
      title:'Geometry Cheat Sheet',
      blurb:'The whole course on one two sided sheet. Formulas on the front, proof and reasoning on the back.',
      kind:'free', course:['geometry'], grade:'9th to 11th',
      sym:'△', color:'peach',
      url:'',
      cta:'Download free',
      pages:2,
      long:'Front: angle relationships, parallel lines and a transversal, triangles, special right triangles, Pythagoras, area, circles, volume, coordinate geometry, right triangle trig and polygons. Back: how to write a two column proof, triangle congruence and similarity, the special segments, the reasons you are allowed to cite, isosceles and equilateral, the quadrilateral family, circle theorems and transformations.',
      added:'2026-09-14'
    },
    {
      id:'algebra2-sheet',
      title:'Algebra 2 Cheat Sheet',
      blurb:'The whole year on one two sided sheet. Every function family, worked.',
      kind:'free', course:['algebra2'], grade:'9th to 11th',
      sym:'x²', color:'sky',
      url:'',
      cta:'Download free',
      pages:2,
      long:'Front: the eight function families with their domains and ranges, transformations, quadratics in three forms, solving a quadratic four ways, complex numbers, polynomials and end behaviour, the factoring toolkit, synthetic division, rational expressions, radicals and rational exponents, and extraneous solutions. Back: exponentials, logarithms, sequences and series, systems, rational asymptotes and holes, variation, inverses, absolute value, conics, inequalities and counting.',
      added:'2026-09-14'
    },
    {
      id:'precalc-sheet',
      title:'Precalculus Cheat Sheet',
      blurb:'The whole year on one two sided sheet, with the full unit circle.',
      kind:'free', course:['precalc'], grade:'10th to 12th',
      sym:'π', color:'peri',
      url:'',
      cta:'Download free',
      pages:2,
      long:'Front: the complete unit circle in degrees and radians with every exact coordinate, the six functions and their signs, graphing sine and cosine, tangent and the reciprocals, inverse trig, the identities, sum difference and double angle, solving a trig equation, and both laws with area. Back: vectors, polar and complex form, parametric equations, conics, sequences and sigma, composition and inverses, limits, rational functions, matrices and logs.',
      added:'2026-09-14'
    },
    {
      id:'calculus-sheet',
      title:'Calculus Cheat Sheet',
      blurb:'AB in full plus the BC essentials, on one two sided sheet.',
      kind:'free', course:['calculus'], grade:'11th to 12th',
      sym:'∫', color:'lilac',
      url:'',
      cta:'Download free',
      pages:2,
      long:'Front: limits and continuity, the derivative and every rule, the derivatives to know cold, chain rule and implicit, related rates, what the first and second derivative tell you, extreme values and the theorems, motion, L Hopital, differential equations and Riemann sums. Back: antiderivatives, u substitution, the Fundamental Theorem, area and volume, linearization, and the BC material marked as BC: parts, partial fractions, parametric and polar, series and convergence, and Taylor.',
      added:'2026-09-14'
    },

    /* ---------- the first six weeks review packets ---------- */
    /* Five free files. Upload each PDF under Content > Files in Shopify,
       copy its link, and paste it into url below. Until then each one
       shows as coming soon, which is safe. */
    {
      id:'six-prealg',
      title:'Pre-Algebra, first six weeks review',
      blurb:'Every first term topic, a mixed review, and a practice test.',
      kind:'free', course:['prealgebra'], grade:'6th to 8th',
      sym:'%', color:'butter',
      url:'',
      cta:'Download free',
      pages:16,
      group:'review', term:'1st six weeks',
      added:'2026-09-13'
    },
    {
      id:'six-alg1',
      title:'Algebra 1, first six weeks review',
      blurb:'Every first term topic, a mixed review, and a 25 question practice test.',
      kind:'free', course:['algebra1'], grade:'8th to 10th',
      sym:'x', color:'blush',
      url:'',
      cta:'Download free',
      pages:16,
      sheet:'algebra1-guide',            /* the matching cheat sheet */
      group:'review', term:'1st six weeks',
      added:'2026-09-13'
    },
    {
      id:'six-alg2',
      title:'Algebra 2, first six weeks review',
      blurb:'Exponents, absolute value, functions, lines and systems, with a practice test.',
      kind:'free', course:['algebra2'], grade:'9th to 11th',
      sym:'x²', color:'sky',
      url:'',
      cta:'Download free',
      pages:16,
      sheet:'algebra2-sheet',            /* the matching cheat sheet */
      group:'review', term:'1st six weeks',
      added:'2026-09-13'
    },
    {
      id:'six-geo',
      title:'Geometry, first six weeks review',
      blurb:'Points and lines through parallel lines and proof reasons, with a practice test.',
      kind:'free', course:['geometry'], grade:'9th to 11th',
      sym:'△', color:'peach',
      url:'',
      cta:'Download free',
      pages:16,
      sheet:'geometry-sheet',            /* the matching cheat sheet */
      group:'review', term:'1st six weeks',
      added:'2026-09-13'
    },
    {
      id:'six-precalc',
      title:'Precalculus, first six weeks review',
      blurb:'Function notation, parent functions, transformations, inverses, with a practice test.',
      kind:'free', course:['precalc'], grade:'10th to 12th',
      sym:'π', color:'peri',
      url:'',
      cta:'Download free',
      pages:17,
      sheet:'precalc-sheet',            /* the matching cheat sheet */
      group:'review', term:'1st six weeks',
      added:'2026-09-13'
    },
    {
      id:'six-calc',
      title:'Calculus, first six weeks review',
      blurb:'Limits, continuity and the IVT, the definition of the derivative, with a practice test.',
      kind:'free', course:['calculus'], grade:'11th to 12th',
      sym:'∫', color:'lilac',
      url:'',
      cta:'Download free',
      pages:17,
      sheet:'calculus-sheet',            /* the matching cheat sheet */
      group:'review', term:'1st six weeks',
      added:'2026-09-13'
    },

        /* ---------- the PAID six weeks packets, Rest of the Year Pass ---------- */
    { id:'six2-alg1', title:'Algebra 1, second six weeks review',
      blurb:'Slope and graphing lines, writing equations, functions, with a practice test.',
      kind:'shop', course:['algebra1'], grade:'8th to 10th', sym:'x', color:'blush',
      url:'', cta:'Get the year pass', price:'$4.99', pages:16,
      group:'review', term:'2nd six weeks', added:'2026-09-16' },
    { id:'six2-alg2', title:'Algebra 2, second six weeks review',
      blurb:'Quadratics and factoring through complex numbers, with a practice test.',
      kind:'shop', course:['algebra2'], grade:'9th to 11th', sym:'x²', color:'sky',
      url:'', cta:'Get the year pass', price:'$4.99', pages:16,
      group:'review', term:'2nd six weeks', added:'2026-09-16' },
    { id:'six2-geo', title:'Geometry, second six weeks review',
      blurb:'Transformations, congruent triangles and proofs, with a practice test.',
      kind:'shop', course:['geometry'], grade:'9th to 11th', sym:'△', color:'peach',
      url:'', cta:'Get the year pass', price:'$4.99', pages:16,
      group:'review', term:'2nd six weeks', added:'2026-09-16' },
    { id:'six2-precalc', title:'Precalculus, second six weeks review',
      blurb:'Polynomial and rational functions, with a practice test.',
      kind:'shop', course:['precalc'], grade:'10th to 12th', sym:'π', color:'peri',
      url:'', cta:'Get the year pass', price:'$4.99', pages:16,
      group:'review', term:'2nd six weeks', added:'2026-09-16' },
    { id:'six2-calc', title:'Calculus, second six weeks review',
      blurb:'Derivative rules through implicit differentiation, with a practice test.',
      kind:'shop', course:['calculus'], grade:'11th to 12th', sym:'∫', color:'lilac',
      url:'', cta:'Get the year pass', price:'$4.99', pages:16,
      group:'review', term:'2nd six weeks', added:'2026-09-16' },

    { id:'six3-prealg', title:'Pre-Algebra, third six weeks review',
      blurb:'Ratios, rates, proportions, percents and simple interest, with a practice test.',
      kind:'shop', course:['prealgebra'], grade:'6th to 8th', sym:'%', color:'butter',
      url:'', cta:'Get the year pass', price:'$4.99', pages:16,
      group:'review', term:'3rd six weeks', added:'2026-09-20' },
    { id:'six3-alg1', title:'Algebra 1, third six weeks review',
      blurb:'Systems of equations and exponent rules, with a practice test.',
      kind:'shop', course:['algebra1'], grade:'8th to 10th', sym:'x', color:'blush',
      url:'', cta:'Get the year pass', price:'$4.99', pages:16,
      group:'review', term:'3rd six weeks', added:'2026-09-20' },
    { id:'six3-alg2', title:'Algebra 2, third six weeks review',
      blurb:'Complex numbers, quadratics and polynomials, with a practice test.',
      kind:'shop', course:['algebra2'], grade:'9th to 11th', sym:'x²', color:'sky',
      url:'', cta:'Get the year pass', price:'$4.99', pages:16,
      group:'review', term:'3rd six weeks', added:'2026-09-20' },
    { id:'six3-geo', title:'Geometry, third six weeks review',
      blurb:'Triangle relationships, polygons and quadrilaterals, with a practice test.',
      kind:'shop', course:['geometry'], grade:'9th to 11th', sym:'△', color:'peach',
      url:'', cta:'Get the year pass', price:'$4.99', pages:16,
      group:'review', term:'3rd six weeks', added:'2026-09-20' },
    { id:'six3-precalc', title:'Precalculus, third six weeks review',
      blurb:'Exponentials and logarithms, with a practice test.',
      kind:'shop', course:['precalc'], grade:'10th to 12th', sym:'π', color:'peri',
      url:'', cta:'Get the year pass', price:'$4.99', pages:16,
      group:'review', term:'3rd six weeks', added:'2026-09-20' },
    { id:'six3-calc', title:'Calculus, third six weeks review',
      blurb:'Extrema, curve analysis, related rates and optimization, with a practice test.',
      kind:'shop', course:['calculus'], grade:'11th to 12th', sym:'∫', color:'lilac',
      url:'', cta:'Get the year pass', price:'$4.99', pages:16,
      group:'review', term:'3rd six weeks', added:'2026-09-20' },

    {
      id:'division-domination',
      title:'Division Domination',
      blurb:'Division practice that builds speed and accuracy.',
      kind:'book', course:['elementary'], grade:'3rd to 5th',
      sym:'÷', color:'seafoam',
      url:'https://www.amazon.com/dp/B0GR4H39RW',
      cta:'Get it on Amazon', img:'',
      long:'Division practice that builds speed and accuracy.',
      series:'Division Domination', part:'Original'
    },

    {
      id:'division-domination-girly',
      title:'Division Domination, Girly Girl',
      blurb:'The same division practice, in full girly girl.',
      kind:'book', course:['elementary'], grade:'3rd to 5th',
      sym:'♡', color:'gum',
      url:'https://www.amazon.com/dp/B0GS9CXTR6',
      cta:'Get it on Amazon', img:'',
      long:'The same division practice, in full girly girl.',
      series:'Division Domination', part:'Girly Girl'
    },

    {
      id:'times-tables',
      title:'Mastering Times Tables 0 to 12',
      blurb:'Every times table from 0 to 12, drilled until it sticks.',
      kind:'book', course:['elementary'], grade:'1st to 5th',
      sym:'×', color:'butter',
      url:'https://www.amazon.com/dp/1941775284',
      cta:'Get it on Amazon', img:'',
      long:'Every times table from 0 to 12, drilled until it sticks.'
    },

    {
      id:'algebra-is-easy',
      title:'Algebra is Easy',
      blurb:'Algebra 1 broken into steps that actually make sense.',
      kind:'book', course:['algebra1','prealgebra'], grade:'6th to 9th',
      sym:'x', color:'sky',
      url:'https://www.amazon.com/dp/194177525X',
      cta:'Get it on Amazon', img:'',
      long:'Algebra 1 broken into steps that actually make sense.',
      series:'Algebra is Easy', part:'Lessons'
    },

    {
      id:'algebra-is-easy-success',
      title:'Algebra is Easy, Success Book',
      blurb:'The practice and tests that go with Algebra is Easy.',
      kind:'book', course:['algebra1','prealgebra'], grade:'6th to 9th',
      sym:'✓', color:'peri',
      url:'https://www.amazon.com/dp/1941775268',
      cta:'Get it on Amazon', img:'',
      long:'Practice problems and tests built on Algebra is Easy, so you can check what actually stuck.',
      series:'Algebra is Easy', part:'Practice and tests'
    },

    /* ---------- newest first ---------- */

    {
      id:'psv-practice',
      title:'Pretty Smart Vocab practice',
      blurb:'1000 SAT words. Flashcards, fill in the blank, matching, speed drill.',
      kind:'tool', course:['sat'], grade:'9th to 12th',
      sym:'★', color:'gum',
      url:'/pages/pretty-smart-vocab',
      cta:'Start practicing',
      added:'2026-09-10'
    },

    {
      id:'psv-book',
      title:'Pretty Smart: 1000 SAT Vocabulary Words',
      blurb:'352 pages, 1150 practice questions, write in workbook.',
      kind:'book', course:['sat'], grade:'9th to 12th',
      sym:'♡', color:'gum',
      url:'https://www.amazon.com/dp/B0HJLBX57L',
      cta:'Get it on Amazon',
      /* the online version of this same book. Shows as a second, quieter
         button on the books page. Any book can have one. */
      also:{ label:'Practice the words online, free', url:'/pages/pretty-smart-vocab' },
      pages:352,
      img:'',                       /* <- paste the cover picture link */
      long:'Ten sets of a hundred words, with three example sentences each, fill in the blank both with hints and without, a line to write your own sentence, prefix and suffix pages, a diagnostic pre-test and a final mastery test.',
      series:'Pretty Smart',
      added:'2026-09-08'
    },

    /* ---------- PAID, part one ----------
       The three paid digital files. Each one needs two things from you:
         1. the listing link, pasted into cc-links.js like everything else
         2. the price, on the price line right here
       Leave price as '' and no price chip shows, which is safe. Put a price
       in and it shows as a small chip on the card, everywhere the card
       appears. Write it the way you want it read, like '$6' or '$6.00'. */
    {
      id:'psv-etsy',
      title:'Pretty Smart vocab, print at home',
      blurb:'All 1000 SAT words as five print at home PDFs. The whole workbook, no shipping.',
      kind:'shop', course:['sat'], grade:'9th to 12th',
      sym:'↓', color:'lilac',
      url:'',                       /* <- paste the listing link in cc-links.js */
      cta:'Buy the PDFs',
      price:'',                     /* <- your price, like '$12' */
      pages:352,
      long:'The same ten sets of a hundred words as the paperback, split into five PDFs so you can print one set at a time. Three example sentences per word, fill in the blank with hints and without, a line to write your own sentence, prefix and suffix pages, a pre-test and a final mastery test.',
      added:'2026-09-08'
    },

    {
      id:'fff-1',
      title:'Fact Family Friends, Book One',
      blurb:'Every composite number 4 to 40, multiply and divide both ways.',
      kind:'book', course:['elementary'], grade:'1st to 3rd',
      sym:'×', color:'blush',
      url:'', cta:'Get it on Amazon', pages:138, img:'',
      long:'Twenty seven numbers, each one drilled forwards and backwards. Factor jumbles, fact triangles, factor rainbows, divisibility rules and a final test.',
      series:'Fact Family Friends', part:'Book One',
      added:'2026-09-08'
    },
    {
      id:'fff-2',
      title:'Fact Family Friends, Book Two',
      blurb:'42 to 70, including the numbers no times table covers.',
      kind:'book', course:['elementary'], grade:'3rd to 5th',
      sym:'÷', color:'mint',
      url:'', cta:'Get it on Amazon', pages:130, img:'',
      long:'Nine of these numbers never appear in a times table, so no other workbook drills them. Same activities as Book One, harder numbers.',
      series:'Fact Family Friends', part:'Book Two',
      added:'2026-09-08'
    },
    {
      id:'fff-3',
      title:'Fact Family Friends, Book Three',
      blurb:'72 to 100. Fourteen of these are outside the times tables.',
      kind:'book', course:['elementary','prealgebra'], grade:'5th to 7th',
      sym:'=', color:'peri',
      url:'', cta:'Get it on Amazon', pages:136, img:'',
      long:'Fourteen of these twenty four numbers are outside the times tables. This is the book that makes big numbers feel easy.',
      series:'Fact Family Friends', part:'Book Three',
      added:'2026-09-08'
    },

    {
      id:'tsia2-practice',
      title:'Pass the TSIA2 Math practice',
      blurb:'236 problems, all four areas. Practice by topic, two full tests, a fix list that remembers what you missed.',
      kind:'tool', course:['tsi'], grade:'11th to adult',
      sym:'✓', color:'seafoam',
      url:'/pages/pass-the-tsia2-math',
      cta:'Start practicing',
      long:'Five tabs: practice by area, full length tests, the lessons, a fix list of everything you got wrong, and your progress. It remembers where you were, so you can close it and come back.',
      added:'2026-09-16'
    },

    {
      id:'tsia2-book',
      title:'Pass the TSIA2 Math',
      blurb:'107 pages. 33 lessons, 4 reference sheets, 4 practice sets and 4 full tests, with every answer worked.',
      kind:'free', course:['tsi'], grade:'11th to adult',
      sym:'✓', color:'mint',
      url:'',                       /* <- paste the PDF file link */
      cta:'Download free',
      pages:107,
      long:'Everything the TSIA2 math test asks for: quantitative reasoning, algebraic reasoning, geometric and spatial reasoning, and probability and statistics. Test facts, test day rules, a score tracker, then 33 short lessons, four practice sets and four full length tests with answer sheets and worked keys. Print at home on letter paper.',
      added:'2026-09-16'
    },

    {
      id:'trig-identities',
      title:'Trig Identities reference',
      blurb:'10 pages, every identity worth knowing, on one sheet per family. No practice, just the reference.',
      kind:'free', course:['precalc','algebra2','calculus'], grade:'10th to 12th',
      sym:'θ', color:'seafoam',
      url:'',                       /* <- paste the PDF file link */
      cta:'Download free',
      pages:10,
      long:'Nine parts, one color each: the basics, negative angles and periods, sum and difference, double and triple angles, half angle and power reducing, products and sums, the triangles they come from, an exact values chart, and inverse trig. Print it once and it lasts the year.',
      added:'2026-09-16'
    },

    {
      id:'spot-the-identity',
      title:'Spot the Identity practice',
      blurb:'13 pages. The same identity wears a different costume every time. This is the practice at recognising it.',
      kind:'free', course:['precalc','algebra2','calculus'], grade:'10th to 12th',
      sym:'θ', color:'gum',
      url:'',                       /* <- paste the PDF file link */
      cta:'Download free',
      pages:13,
      long:'A tells table, one fully worked example, then seven sets: match them up, name the family, spot the disguise, costumes, true or false, fill the blank, and a speed round. Three answer key pages at the back. Pairs with the Trig Identities reference sheet.',
      added:'2026-09-16'
    },

    {
      id:'parent-functions',
      title:'Parent Functions worksheet',
      blurb:'15 pages, 131 problems. All fifteen parent graphs, every transformation, with a full worked key.',
      kind:'free', course:['algebra2','precalc','algebra1'], grade:'8th to 12th',
      sym:'π', color:'peri',
      url:'',                       /* <- paste the PDF file link */
      cta:'Download free',
      pages:15,
      long:'All fifteen parent graphs on one page with their domains and ranges. Then the practice: name the family, domain and range after a move, h and k, stretch shrink and flip, all four at once, fill a table and graph it, and where the vertex, the starting point and the asymptotes land. Four answer key pages show the step, not just the answer.',
      added:'2026-09-14'
    },

    {
      id:'functions-packet',
      title:'Functions practice packet',
      blurb:'14 pages, 102 problems. Domain, range, notation, graphs, shifts, with a full worked key.',
      kind:'free', course:['algebra2','algebra1'], grade:'8th to 11th',
      sym:'ƒ', color:'sky',
      url:'',                       /* <- paste the PDF file link */
      cta:'Download free',
      pages:14,
      long:'Is it a function, function notation, domain and range from a list, a table and a graph, linear functions, writing the rule from a table or a story, the four parent functions, shifts, and a mixed page. Four answer key pages show the step, not just the answer.',
      added:'2026-09-13'
    },

    /* ---------- PAID, part two ---------- */
    {
      id:'desmos-guide',
      title:'Pretty Smart Desmos',
      blurb:'The digital SAT calculator, every move worth knowing.',
      kind:'shop', course:['sat'], grade:'9th to 12th',
      sym:'▦', color:'seafoam',
      url:'',                       /* <- paste the listing link in cc-links.js */
      cta:'Buy the guide',
      price:'',                     /* <- your price, like '$6' */
      long:'Every Desmos move that is worth knowing on the digital SAT, with the exact keystrokes. Solving without algebra, systems, quadratics, regressions, inequalities and the shortcuts that turn a two minute problem into a ten second one.',
      added:'2026-09-07'
    },

    {
      id:'algebra1-guide',
      title:'Algebra 1 Cheat Sheet',
      blurb:'The whole year on one two sided sheet. 29 boxes, every rule worked out.',
      kind:'free', course:['algebra1'], grade:'8th to 10th',
      sym:'x', color:'blush',
      url:'',
      cta:'Download free',
      pages:2,
      long:'Front: signed numbers, absolute value, distributing and FOIL, order of operations, evaluating, translating words, like terms, factoring, slope and the three forms, exponent rules, square roots, fractions all four ways, scientific notation, negative exponents. Back: graphing lines, writing the equation of a line, horizontal and vertical lines, solving equations, systems by substitution and elimination, intercepts, the quadratic formula with vertex and axis of symmetry, inequalities and how to graph them, absolute value equations, midpoint, distance, parallel and perpendicular. Print it two sided and it lives in the front of the binder.',
      added:'2026-09-14'
    },

    /* ---------- PAID, part three ----------
       The booklet, which is a different product from the free one sheet
       above. Thirteen pages, one unit per page, 58 worked examples. The
       free cheat sheet is the sample. This is the long version. */
    {
      id:'algebra1-booklet',
      title:'Algebra 1, The Whole Year',
      blurb:'A 13 page reference booklet. One unit per page, 58 worked examples.',
      kind:'shop', course:['algebra1'], grade:'8th to 10th',
      sym:'x', color:'gum',
      url:'',                       /* <- paste the listing link in cc-links.js */
      cta:'Buy the booklet',
      price:'',                     /* <- your price, like '$8' */
      pages:13,
      long:'Every Algebra 1 unit on its own page. The language of algebra, solving, inequalities, lines twice over, systems, exponents and polynomials, factoring, quadratics, functions and sequences, word problems, and the ten most expensive mistakes. Print it, punch it, keep it in the front of the binder.',
      added:'2026-09-13'
    },


    /* ============ COPY ME ============================
    ,{
      id:'',
      title:'',
      blurb:'',
      kind:'free',
      course:['algebra1'],
      grade:'',
      sym:'+', color:'mint',
      url:'',
      cta:'Download free',
      added:'2026-09-10'
    }
    ================================================== */

  ],

  /* ------------------------------------------------------------
     Your links live in cc-links.js, not here. Anything you put
     there wins over the url lines above, so a catalog update can
     never wipe a link you pasted. This runs whichever of the two
     files the browser happens to finish first.
     ------------------------------------------------------------ */
  applyLinks: function () {
    var L = window.CC_LINKS;
    if (!L || !window.CC_CATALOG) return;
    window.CC_CATALOG.items.forEach(function (i) {
      if (Object.prototype.hasOwnProperty.call(L, i.id) && L[i.id]) i.url = L[i.id];
    });
  }
};

window.CC_CATALOG.applyLinks();